/** @format */

import React from "react";
import { Select, Radio } from "antd";
import { sortApply } from "../../utils/GTMDataLayer";

const { Option } = Select;

const setOFValues = ['createdTs', 'minimumOrderQuantity', 'popularity', 'price-high-to-low', 'price-low-to-high', 'publishedTimeStamp'];

function SortByFilter(props) {
  let { id = "" } = props;
  if (id === "PLP" || id === "SPLP") {
    return (
      <div className="seller-sort-list">
        {props.device === "mobile" ? (
          <>
            <Radio.Group
              onChange={(e) => {
                sortApply("", e);
                props.handleSortFilter(e);
              }}
              value={setOFValues.includes(props.queryParams.sort_by) ? encodeURIComponent(props.queryParams.sort_by) : 'popularity'}
              className="radio-group"
            >
              <Radio value="createdTs" className="qa-radio-home">
                New Arrivals
              </Radio>
              <Radio value="minimumOrderQuantity" className="qa-radio-home">
                Order type
              </Radio>
              <Radio value="popularity" className="qa-radio-home">
                Popularity
              </Radio>
              <Radio value="price-high-to-low" className="qa-radio-home">
                Price High to low
              </Radio>
              <Radio value="price-low-to-high" className="qa-radio-home">
                Price Low to high
              </Radio>
            </Radio.Group>
          </>
        ) : (
          <>
            <span className="qa-font-san qa-pad-rgt-1">Sort by</span>
            <Select
              // defaultValue="popularity"
              dropdownClassName="qa-light-menu-theme"
              style={{ width: props.width || 180, display: "inline-block" }}
              onChange={(e) => {
                sortApply("", e);
                props.handleSortFilter(e);
              }}
              value={setOFValues.includes(props.queryParams.sort_by) ? encodeURIComponent(props.queryParams.sort_by) : 'popularity'}
            >
              <Option value="createdTs">New Arrivals</Option>
              <Option value="minimumOrderQuantity">Order type</Option>
              <Option value="popularity">Popularity</Option>
              <Option value="price-high-to-low">Price High to low</Option>
              <Option value="price-low-to-high">Price Low to high</Option>
            </Select>
          </>
        )}
      </div>
    );
  } else {
    return (
      <div className="seller-sort-list">
        {props.device === "mobile" ? (
          <>
            <Radio.Group
              onChange={(e) => {
                sortApply("", e);
                props.handleSortFilter(e);
              }}
              value={setOFValues.includes(props.queryParams.sort_by) ? encodeURIComponent(props.queryParams.sort_by) : 'popularity'}
              className="radio-group"
            >
              <Radio value="publishedTimeStamp" className="qa-radio-home">
                New
              </Radio>
              <Radio value="popularity" className="qa-radio-home">
                Popularity
              </Radio>
            </Radio.Group>
          </>
        ) : (
          <>
            <span className="qa-font-san qa-pad-rgt-1">Sort by:</span>
            <Select
              // defaultValue="popularity"
              dropdownClassName="qa-light-menu-theme"
              style={{ width: props.width || 120, display: "inline-block" }}
              onChange={(e) => {
                sortApply("", e);
                props.handleSortFilter(e);
              }}
              defaultValue={setOFValues.includes(props.queryParams.sort_by) ? encodeURIComponent(props.queryParams.sort_by) : 'popularity'}
            >
              <Option value="publishedTimeStamp">New</Option>
              <Option value="popularity">Popularity</Option>
            </Select>
          </>
        )}
      </div>
    );
  }
}

export default SortByFilter;